import React, { useState } from "react";
import UploadImage from "../../components/common/UploadImage/UplaodImage";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import FormInput from "../../components/common/FormInput/FormInput";
import { addGallery } from "../../api/service/gallery.service";
import "./Gallery.css";
import Button from "../../components/common/Button/Button";
import { useNavigate } from "react-router-dom";

const Gallery = ({ setLoading }) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);




  const handleFileSelect = (file) => {
    const preview = URL.createObjectURL(file);

    setImages((prev) => [
      ...prev,
      {
        file,
        preview,
      },
    ]);
  };

  const handleRemove = (index) => {
    setImages((prev) => {
      URL.revokeObjectURL(prev[index].preview);
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleUpdate = () => {
    Swal.fire({
      title: "Update Image",
      text: "Image update logic can be added here",
      icon: "info",
      confirmButtonColor: "#C39B22",
    });
  };

  const handleDelete = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This image will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleRemove(index);
        Swal.fire("Deleted!", "Image deleted successfully.", "success");
      }
    });
  };



  const handleSubmit = async () => {
    if (!title || !category || images.length === 0) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
     console.log(formData)
      formData.append("title", title);
      formData.append("category", category);
      formData.append("description", description);


      images.forEach((img) => {
        formData.append("image", img.file);
      });

      await addGallery(formData);
// console.log(resp,"resp...............")


      Swal.fire("Success", "Gallery added successfully", "success");

      setTitle("");
      setCategory("");
      setImages([]);
      setDescription("");

      // navigate("/gallery");
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };




  return (
    <div className="container-fluid">

      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => window.history.back()}
        />
        <h3 className="management-tile mb-0 ml-2">
          Gallery Management
        </h3>
      </div>


      <Row className="galleryform-container">
        <Col md={6} className="mb-3">
          <FormInput
            placeholder="Enter gallery Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Col>

        <Col md={6} className="mb-3">
          <FormInput
            placeholder="Enter gallery Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </Col>
        <Col xs={12} Name="mb-3">
          <FormInput
            type="textarea"
            placeholder="Enter gallery description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Col>

        <Col xs={12} className="mb-3">
          <UploadImage onFileSelect={handleFileSelect} />
        </Col>
      </Row>


      <div className="row g-3">
        {images.map((img, index) => (
          <div key={index} className="col-lg-4 col-md-6 col-sm-12">
            <div className="image-preview-box mt-2">
              <div className="image-actions">
                <span
                  className="icon-btn"
                  title="Update"
                  onClick={() => handleUpdate(index)}
                >
                  <FaRegEdit size={15} />
                </span>

                <span
                  className="icon-btn delete"
                  title="Delete"
                  onClick={() => handleDelete(index)}
                >
                  <MdDelete size={16} />
                </span>
              </div>
              {/* 
              <img
                src={img.preview}
                alt="uploaded"
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "264px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              /> */}
            </div>
          </div>
        ))}
      </div>


      <div className="mt-4">
        <Button
          className="btn btn-primary"

          onClick={handleSubmit}
        >
          Save Gallery
        </Button>
      </div>
    </div>
  );
};

export default Gallery;
